import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAssessmentAttachments(assessmentId) {
  const response = await $.soap({
    body: {
      GetAssessmentAttachments: {
        $xmlns: 'http://dla.mil/ems/bpm/attachment',
        AssessmentID: assessmentId
      }
    },
    blueprintArrays: ['GetAssessmentAttachmentsResponse.Attachments.Attachment'],
    blueprint: {
      attachments: [
        '$..Attachment',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          documentTypeId: '$..DocumentTypeID',
          fileName: '$..FileName',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.attachments;
}
